import {useAuth} from '../../../app/modules/auth'

type MenuItem = {
  id?: string;
  title: string;
  icon?: string;
  to: string;
  fontIcon?: string;
  subItems?: MenuItem[];
  hasBullet?: boolean;
  translate?: boolean;
}
export const useMenuPermission = () => {
  const {currentUser} = useAuth();

  const filterMenuItems = (menuItems: MenuItem[]): MenuItem[] => {
    if(currentUser?.menuItemsAll)
      return menuItems;
    return menuItems.filter((menuItem:MenuItem) => {
      if (!currentUser?.menuItems || currentUser.menuItems.length === 0) {
        return menuItem;
      }

      return currentUser.menuItems.some(
        (userMenuItem) => userMenuItem.transKey === menuItem.title
      );
    });
  };

  const isMenuItemAllowed = (transKey: string): boolean => {
    if(currentUser?.menuItemsAll)
      return true;
    if (!currentUser?.menuItems) {
      return false;
    }

    return currentUser.menuItems.some(item => item.transKey === transKey);
  };

  return {
    isMenuItemAllowed, filterMenuItems
  };
};
